export default __webpack_public_path__ + "static/media/subtitle-icon.c492c0bb.svg";